"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpIdleTimeOut = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_idle_timer_1 = __importDefault(require("react-idle-timer"));
var context_1 = require("../../../api/context");
var idleTimeOut_constants_1 = require("../../../api/constants/idleTimeOut.constants");
var DpIdleTimeOutModal_1 = require("./IdleTimeOutModal/DpIdleTimeOutModal");
var useHttpErrorHandler_hook_1 = require("../../../api/hooks/useHttpErroHandler/useHttpErrorHandler.hook");
var DpIdleTimeOut = function (_a) {
    var user = _a.user;
    // ------------------------------ Context
    var authService = (0, react_1.useContext)(context_1.ServiceContext).authService;
    var handleHTTPError = (0, useHttpErrorHandler_hook_1.useHttpErroHandler)().handleHTTPError;
    // ----------------------------------------- State
    var _b = (0, react_1.useState)(false), showIdleTimeOutModal = _b[0], setShowIdleTimeOutModal = _b[1];
    // ------------------------------- Const
    var idleTimer = null;
    // ------------------------------- Methods
    var onAction = function () {
        if (idleTimer)
            idleTimer.reset(); // reset the timer when the user did something
    };
    var onIdle = function () {
        setShowIdleTimeOutModal(true);
    };
    var extendSession = function () {
        idleTimer.reset();
        setShowIdleTimeOutModal(false);
    };
    var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var logoutData, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, authService.logout()];
                case 1:
                    logoutData = _a.sent();
                    window.location.assign(logoutData.redirectUrl);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    handleHTTPError(err_1)();
                    return [3 /*break*/, 3];
                case 3:
                    setShowIdleTimeOutModal(false);
                    return [2 /*return*/];
            }
        });
    }); };
    // ----------------------------------------- Render
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_idle_timer_1.default, { ref: function (ref) {
                    idleTimer = ref;
                }, element: document, onIdle: onIdle, onAction: onAction, debounce: 250, timeout: user.isStudent ? idleTimeOut_constants_1.STUDENTS_TIMEOUT : idleTimeOut_constants_1.OTHERS_TIMEOUT, stopOnIdle: true }), showIdleTimeOutModal && ((0, jsx_runtime_1.jsx)(DpIdleTimeOutModal_1.DpIdleTimeOutModal, { show: showIdleTimeOutModal, closeHandler: extendSession, submitHandler: logout }))] }));
};
exports.DpIdleTimeOut = DpIdleTimeOut;
exports.default = exports.DpIdleTimeOut;
